module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_marco_comida_25.38a2019b.png";